module.exports = "/fonts/developer-picturemark-d-1101a42927343a1ec3b88f1fb049b6ff.svg";